import { EventCallback } from "../../models/event/EventCallback";

export type StringSignalValue = number | boolean | string | null;

export class StringSignalHub {
  private values = new Map<string, StringSignalValue>();

  constructor(private readonly emit: (eventName: string, payload?: any) => void) {}

  publish(objectId: string, signal: string, value: StringSignalValue): void {
    const key = this.getKey(objectId, signal);
    this.values.set(key, value);
    this.emit(this.getEventName(objectId, signal), value);
  }

  subscribe(
    objectId: string,
    signal: string,
    events: {
      on<T = any>(eventName: string, callback: EventCallback<T>, id?: string | null): void;
    },
    callback: EventCallback<StringSignalValue>,
  ): void {
    events.on(this.getEventName(objectId, signal), callback);
  }

  unsubscribe(
    objectId: string,
    signal: string,
    events: {
      off<T = any>(eventName: string, callback: EventCallback<T>, id?: string): void;
    },
    callback: EventCallback<StringSignalValue>,
  ): void {
    events.off(this.getEventName(objectId, signal), callback);
  }

  get(objectId: string, signal: string): StringSignalValue | undefined {
    return this.values.get(this.getKey(objectId, signal));
  }

  getEventName(objectId: string, signal: string): string {
    return `signal:${objectId}:${signal}`;
  }

  private getKey(objectId: string, signal: string): string {
    return `${objectId}.${signal}`;
  }
}
